var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "damage-validation-frais" },
    [
      _c("ma-navbar-stepper", {
        attrs: { numberOfStep: 3, textOfStep: _vm.$t("stepper.step3") },
      }),
      _c("div", { staticClass: "view damage-validation-frais__container" }, [
        _c("div", { staticClass: "view_content" }, [
          _c("div", { staticClass: "view_content_markdown" }, [
            _c("h1", { staticClass: "headline-large-bold" }, [
              _vm._v(_vm._s(_vm.$t("damageFraisValidation.title"))),
            ]),
            _c("img", {
              staticClass: "mg mg--t-4",
              attrs: { src: require("@/assets/images/self-care/frais.png") },
            }),
            _c(
              "div",
              {
                staticClass:
                  "claim-compensation-mobilier_total left mg mg--b-8",
              },
              [
                _c("h3", { staticClass: "solution-title" }, [
                  _vm._v(_vm._s(_vm.$t("damageFraisValidation.solution"))),
                ]),
                _c("p", { staticClass: "solution-text" }, [
                  _vm._v(_vm._s(_vm.$t("damageFraisValidation.text"))),
                ]),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("damageFraisValidation.text1"))),
                ]),
              ]
            ),
            _c("div", { staticClass: "view_content_compensation mg mg--b-4" }, [
              _c("div", { staticClass: "damage-validation_compensation" }, [
                _c(
                  "h3",
                  { staticClass: "headline-large damage-validation_title" },
                  [_vm._v(" " + _vm._s(_vm.fraisCompensation) + "€")]
                ),
                _c("div", { staticClass: "summary_frais" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "summary_frais_amount" }, [
                    _c("p", { staticClass: "text-small gray mg mg--t-1" }, [
                      _vm._v(_vm._s(_vm.fraisDamages[0]) + "€"),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "damage-validation_details mg mg--t-4" },
                  [
                    _c("p", { staticClass: "text-medium gray mg mg--t-1" }, [
                      _vm._v("Base d’indemnisation"),
                    ]),
                    _c("p", { staticClass: "text-medium gray mg mg--t-1" }, [
                      _vm._v(_vm._s(_vm.fraisCompensation) + "€"),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "content-material mg mg--t-4" },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "text-small",
                        on: { click: _vm.handleOpenDescriptionModal },
                      },
                      [
                        _c("span", { staticClass: "blueDark mg mg--r-1" }, [
                          _vm._v("Comment est calculée cette indemnisation ?"),
                        ]),
                        _c("svgicon", {
                          attrs: {
                            name: "question",
                            color: "#005BA5",
                            width: "12",
                            height: "12",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "ma-modal",
                      {
                        ref: "modalDescription",
                        staticClass: "modal-confirmation",
                        attrs: { type: "smallCenter" },
                        on: { "modal:close": _vm.handleCloseDescriptionModal },
                      },
                      [
                        _c("template", { slot: "modalContent" }, [
                          _c("div", { staticClass: "modal__main view" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "headline-medium center gray mg mg--b-5",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("damageFraisValidation.modal.title")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-small gray mg mg--b-2 align-self-start",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("damageFraisValidation.modal.text1")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "ul",
                              { staticClass: "withDisc align-self-start" },
                              [
                                _c(
                                  "li",
                                  { staticClass: "text-small gray mg mg--b-2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "damageFraisValidation.modal.list1"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "p",
                              { staticClass: "text-small gray mg mg--b-2" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("damageFraisValidation.modal.text2")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "withDisc align-self-start custom-bullet",
                              },
                              [
                                _c(
                                  "li",
                                  { staticClass: "text-small gray mg mg--b-6" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "damageFraisValidation.modal.list2"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn mainBlue damage-validation_button",
                                on: { click: _vm.handleCloseDescriptionModal },
                              },
                              [
                                _c("p", { staticClass: "text-medium" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "damageFraisValidation.modal.close"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$t("damageFraisValidation.text2")))]),
            _c("p", [_vm._v(_vm._s(_vm.$t("damageFraisValidation.text3")))]),
            _c("p", [_vm._v(_vm._s(_vm.$t("damageFraisValidation.text4")))]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "view_actions" },
        [
          _c("ma-buttons-next-actions", {
            staticClass: "buttonsNextActions",
            attrs: {
              handleButtonClick: _vm.handlePrimaryButtonClick,
              handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClick,
              title: _vm.$t("damageFraisValidation.actions.primary"),
              titleWhiteBtn: _vm.$t("damageFraisValidation.actions.secondary"),
              btnType: "functionalBtnWhite",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary_frais_literals" }, [
      _c("p", { staticClass: "text-small gray mg mg--t-1" }, [
        _vm._v("Recherche de fuite"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }